module.exports = __webpack_public_path__ + "assets/img/fnctwo.c70dba71.png";